/**
 * @flow
 * @relayHash 302dd75174912393770688b355b5a1af
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteUnityMutationVariables = {|
  id: string
|};
export type DeleteUnityMutationResponse = {|
  +deleteUnity: {|
    +id: string
  |}
|};
export type DeleteUnityMutation = {|
  variables: DeleteUnityMutationVariables,
  response: DeleteUnityMutationResponse,
|};
*/


/*
mutation DeleteUnityMutation(
  $id: String!
) {
  deleteUnity(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteUnity",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "UnityModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteUnityMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteUnityMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteUnityMutation",
    "id": null,
    "text": "mutation DeleteUnityMutation(\n  $id: String!\n) {\n  deleteUnity(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '53093d8505a61d587b8e040a67173be4';
module.exports = node;
